<div class="newsletter-modal" [id]="sourceId">
  <div class="newsletter-modal-dialog">
    <div class="newsletter-modal-content">
      <div class="newsletter-modal-header">
        <button type="button" class="newsletter-btn-close" id="modal-dismiss" aria-label="Close" (click)="close()"></button>
      </div>
      <div class="newsletter-modal-body">
        <app-subscribe-newsletter
          [newsletterFooter]="false"
          [newsletterSource]="'newsletter-modal'"
          (closeModalEvent)="close()"
        />
      </div>
    </div>
  </div>
</div>
